<app-document-viewer-page label="Términos y condiciones" [url]="url">
</app-document-viewer-page>

